// @flow
// holds the default state of our store.

const initialState = {
    
    device: {               // for updating the webservice on what status we are currently in (so it can log/respond)
        status: "unknown",  // status of the device (unknown, idle, busy, error)
        mode: "unknown",    // mode of the device (load, discard, reload, etc.)
    },
    
    serverInfo: {
        deviceSerialNum: '',
        deviceFWVersion: '',
        deviceWSVersion: '',
        status: '',
        state: '',
        lightColor: '',
        lightFlash: false,
        uptimeSecs: 0,
        retryReconnect: false,
        lastError: '',
        systemTicks: '',
        initialized: false,     // kicker
        name: "-",              // our device name  (from webservice)
        version: "-",           // webservice version (from webservice)
        id: "-",                // our device id (from webservice)
        config: {
            inactiveTimeout: 0, // auto-logout time (in seconds == 0 is disabled) - added by pott - 250831
        },            
    },
    
    clientInfo: {
        fullName: '',
        userId: -1,
        level: '',
        clientId: -1,       // fw client id for coms with FW.
        isLoggedInToFW: false,
        error: null,        // will be non-null/empty if fw had an error processing a login
    },
    
    magInfo: {                  // THIS IS THE V1 MAG INFO
        initialized: false,
        barcode: '',
        wrongMag: false,        // set if the wrong mag is place (so we don't show a mag image
        sectionA: {
            numSamples: 0,
            isFull: false
        },
        sectionB: {
            numSamples: 0,
            isFull: false
        },
        sectionC: {
            numSamples: 0,
            isFull: false
        },
        sectionD: {
            numSamples: 0,
            isFull: false
        },
    },
 
    statsInfo: {                // the stats that come from the server periodically
        needsInitialize: true,   // trigger for forcing request to server   
        numSamplesForever: 0,
        numSamplesLeftCamForever: 0,
        numSamplesRightCamForever: 0,
        numSamplesToday: 0,
        numProblemsToday: 0,
        numUnreadableToday: 0,
        numMissingInfoToday: 0,
        numValidationFailedToday: 0,
        numSamplesPerHourToday: 0,
    },

    profiles: {
        initialized: false,
        items: []
    },       // list of profiles
    
    profileSet: {
        initialized: false, // set to true when a result has come back
        curProfileSet: {
            name: "",
            description: "",
            id: -1,
            profileList: [],
        },   // the current profile set
    },

    magTypes: {
        initialized: false,
        items: [] // list of mag types
    },

    sampleTypes: {
        initialized: false,
        items: [] // list of sample types
    },
    
    syncLog: {
        initialized: false,
        numSyncItems: 0,
    },
    
    remoteUserInfo: {
        initialized: false,
        name: null,           // user name
        time: null,           // time of login
        from: null            // sitting at machine info
    }
};

export default initialState;